<div class="modal">
  <div class="close-link">
    <span class="close" [mat-dialog-close]></span>
  </div>
  <ng-container *ngIf="type === 'waiter'; else restaurant">
    <h1 class="modal__tables__title">{{ name + ' ' +  ('pages.waiters.table.modal.title' | translate) }}</h1>
    <ol class="modal__tables__list">
      <li *ngFor="let ell of tables;">
        <span>{{ ell.name }}</span>
      </li>
    </ol>
  </ng-container>

  <ng-template #restaurant>
    <h1 class="modal__tables__title">{{ name + ' ' +  ('pages.chains.menuContent.modalHeader' | translate) }}</h1>
    <ol class="modal__tables__list" *ngIf="type === 'restaurant'">
      <li *ngFor="let ell of restaurantIds">
        {{ restaurantNames[ell] }}
      </li>
    </ol>
  </ng-template>

</div>
